module.exports = __webpack_public_path__ + "img/lifestyle.0dbe530.jpg";